<template>
  <div class="dashBoradWrap">
    <div class="dashBoradMessage">
      <p>Hello, {{ userName }}! <br />Today is {{ formattedDate }}</p>

      <div class="clockInOutWrap">
        <button
          @click="openClockInModal"
          class="clockIn bgBlu"
          :disabled="isClockedIn"
        >
          Clock In
        </button>
        <button
          @click="handleClockOut"
          class="clockOut bgGre"
          :disabled="!isClockedIn || isClockedOut"
        >
          Clock Out
        </button>
      </div>
    </div>

    <div class="menuWrap">
      <router-link to="/attendance/monthlycalendar">
        <svg
          width="50"
          height="50"
          viewBox="0 0 29 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="grad1" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="#0656A2" />
              <stop offset="100%" stop-color="#3CA0A6" />
            </linearGradient>
            <clipPath id="clip0_108_1986">
              <rect
                width="28.0907"
                height="28.8889"
                fill="white"
                transform="translate(0.510193 0.777771)"
              />
            </clipPath>
          </defs>
          <g clip-path="url(#clip0_108_1986)">
            <path
              d="M8.52911 6.61903C9.43155 6.61903 10.1634 5.88721 10.1634 4.98426V2.41202C10.1634 1.50959 9.43155 0.777771 8.52911 0.777771C7.62616 0.777771 6.89435 1.50959 6.89435 2.41202V4.98432C6.89435 5.88721 7.62616 6.61903 8.52911 6.61903Z"
              fill="url(#grad1)"
            />
            <path
              d="M20.5824 6.61903C21.4849 6.61903 22.2167 5.88721 22.2167 4.98426V2.41202C22.2168 1.50959 21.4849 0.777771 20.5824 0.777771C19.6796 0.777771 18.9477 1.50959 18.9477 2.41202V4.98432C18.9477 5.88721 19.6796 6.61903 20.5824 6.61903Z"
              fill="url(#grad1)"
            />
            <path
              d="M24.6646 3.10733H23.6532V4.98426C23.6532 6.67793 22.2757 8.05551 20.5825 8.05551C18.8888 8.05551 17.5113 6.67793 17.5113 4.98426V3.10733H11.5998V4.98426C11.5998 6.67793 10.2223 8.05551 8.52912 8.05551C6.8355 8.05551 5.45787 6.67793 5.45787 4.98426V3.10733H4.44647C2.27258 3.10733 0.510193 4.86967 0.510193 7.04361V25.7304C0.510193 27.9043 2.27264 29.6667 4.44647 29.6667H24.6646C26.8385 29.6667 28.6009 27.9043 28.6009 25.7304V7.04361C28.6009 4.86972 26.8385 3.10733 24.6646 3.10733ZM25.503 25.0392C25.503 26.0451 24.6847 26.8634 23.6789 26.8634H5.43219C4.42639 26.8634 3.60807 26.0451 3.60807 25.0392V10.4192H25.5031L25.503 25.0392Z"
              fill="url(#grad1)"
            />
            <path
              d="M13.7611 21.7543H10.8727V24.6428H13.7611V21.7543Z"
              fill="url(#grad1)"
            />
            <path
              d="M13.7611 17.2771H10.8727V20.1654H13.7611V17.2771Z"
              fill="url(#grad1)"
            />
            <path
              d="M9.28423 21.7543H6.3959V24.6428H9.28423V21.7543Z"
              fill="url(#grad1)"
            />
            <path
              d="M9.28423 17.2771H6.3959V20.1654H9.28423V17.2771Z"
              fill="url(#grad1)"
            />
            <path
              d="M22.7151 12.7998H19.8268V15.6882H22.7151V12.7998Z"
              fill="url(#grad1)"
            />
            <path
              d="M18.2388 12.7998H15.35V15.6882H18.2388V12.7998Z"
              fill="url(#grad1)"
            />
            <path
              d="M18.2388 17.2771H15.35V20.1654H18.2388V17.2771Z"
              fill="url(#grad1)"
            />
            <path
              d="M22.7151 21.7543H19.8268V24.6428H22.7151V21.7543Z"
              fill="url(#grad1)"
            />
            <path
              d="M22.7151 17.2771H19.8268V20.1654H22.7151V17.2771Z"
              fill="url(#grad1)"
            />
            <path
              d="M18.2388 21.7543H15.35V24.6428H18.2388V21.7543Z"
              fill="url(#grad1)"
            />
          </g>
        </svg>
        <span>Attendance</span>
      </router-link>

      <router-link to="/application/holiday">
        <svg
          width="50"
          height="50"
          viewBox="0 0 40 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="grad1" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="#0656A2" />
              <stop offset="100%" stop-color="#3CA0A6" />
            </linearGradient>
          </defs>
          <path
            d="M7.66104 28.6663L4.67495 35.0321C4.2973 35.835 4.643 36.7901 5.44643 37.1671L5.95667 37.4068C6.75893 37.7827 7.71651 37.4371 8.09175 36.6348L11.8277 28.6724H7.81385C7.76331 28.6724 7.71221 28.6706 7.66104 28.6663Z"
            fill="url(#grad1)"
          />
          <path
            d="M34.0436 26.7844L33.7528 27.4055C33.3923 28.1757 32.6086 28.6724 31.7594 28.6724H30.7588L34.4947 36.6348C34.87 37.437 35.8275 37.7827 36.6298 37.4068L37.1412 37.1671C37.9435 36.7901 38.2892 35.8349 37.9114 35.032L34.0436 26.7844Z"
            fill="url(#grad1)"
          />
          <path
            d="M39.3841 10.2139L37.9041 9.52011C37.3686 9.26871 36.7314 9.49917 36.4807 10.034L30.3288 23.1483C30.1525 23.5235 29.7748 23.7638 29.3595 23.7638H7.81518C7.22362 23.7638 6.74487 24.2431 6.74487 24.8341V26.4695C6.74487 27.0604 7.22362 27.5392 7.81518 27.5392H31.7589C32.1736 27.5392 32.5513 27.2995 32.7275 26.9236L39.8988 11.6379C40.1495 11.1025 39.919 10.4654 39.3841 10.2139Z"
            fill="url(#grad1)"
          />
          <path
            d="M16.311 23.0084H18.2533L15.7644 12.7594L29.7697 9.35804L29.1296 8.35609C26.2532 3.85304 21.2387 1.06422 15.8359 1.06297C14.7434 1.06297 13.6368 1.17812 12.5289 1.41476L12.161 0L10.8819 0.332812L11.2497 1.74695C8.25749 2.65148 5.70773 4.38117 3.80554 6.62281C1.72476 9.07406 0.409765 12.1364 0.109062 15.4041L0 16.5883L13.9301 13.2049L16.311 23.0084ZM27.0031 8.28156L21.6004 9.59405L21.7119 9.54413C20.6878 7.25507 19.3851 5.34234 17.939 3.97937C17.4374 3.50797 16.918 3.10437 16.3849 2.77406C20.5818 2.93867 24.4792 4.99296 27.0031 8.28156ZM13.6041 2.94297C14.1149 2.99164 14.6412 3.14265 15.1773 3.39953C16.168 3.87281 17.1823 4.70406 18.1269 5.83046C19.0395 6.91679 19.8855 8.27734 20.599 9.83687L15.0701 11.1795L12.9577 3.06125C13.1734 3.01625 13.3891 2.9775 13.6041 2.94297ZM7.16984 13.0755L7.29187 13.0688L1.96492 14.3627C2.40859 11.9011 3.49984 9.60765 5.10132 7.7221C6.12914 6.5107 7.36648 5.46867 8.77507 4.65476C8.40656 5.27836 8.09913 5.98015 7.85382 6.74796C7.38007 8.23234 7.13476 9.96132 7.13476 11.8345C7.13484 12.2412 7.14648 12.6559 7.16984 13.0755ZM8.2932 12.8253C8.27718 12.4907 8.26734 12.1592 8.26734 11.8345C8.26609 9.4696 8.6864 7.37953 9.42577 5.83718C9.79554 5.06515 10.2423 4.43172 10.7462 3.95968C10.9305 3.78718 11.1221 3.63617 11.3205 3.50625C11.4388 3.46679 11.5584 3.42984 11.6785 3.39281L13.7852 11.4919L8.2932 12.8253Z"
            fill="url(#grad1)"
          />
        </svg>
        <span>Day Off</span>
      </router-link>
    </div>

    <ClockInModal
      v-if="showClockInModal"
      @close="showClockInModal = false"
      @clock-in="handleClockIn"
    />
    <ConfirmationModal
      :visible="showClockOutConfirmation"
      message="Are you sure you want to clock out?"
      @confirm="confirmClockOut"
      @cancel="cancelClockOut"
    />
    <CancelConfirmationModal
      :visible="showCancelSeatConfirmation"
      message="You have a seat reservation for today. Do you want to cancel it and clock in?"
      @confirm="confirmCancelSeatAndClockIn"
      @cancel="cancelSeatCancellation"
    />
  </div>
</template>
<style>
.dashBoradMessage {
  text-align: center;
  border-bottom: dashed 1px var(--blue);
  margin: 5vh 0;
  padding: 5vh;

  & p {
    color: var(--blue);
    font-weight: 600;
    font-size: 20px;
    line-height: 1.8;
    &:nth-child(2) {
      margin-bottom: 2rem;
    }
  }
  & .clockInOutWrap {
    display: flex;
    justify-content: center;
  }
  & button {
    width: 150px;
    height: 150px;
    border-radius: 100px;
    border: none;
    color: white;
    font-weight: 600;
    font-size: 20px;
    cursor: pointer;
    &:disabled {
      background: #c2c2c2;
      color: #a9a9a9;
    }
    &:not(:last-child) {
      margin-right: 2rem;
    }
  }
}
.menuWrap {
  display: flex;
  justify-content: center;
  & > a {
    width: 100px;
    height: 95px;
    border: 1px solid;
    text-align: center;
    padding: 2rem;
    color: black;
    text-decoration: none;
    position: relative;
    border: none;
    background: white;
    z-index: 1;
    &::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 1000px;
      padding: 2px;
      background: linear-gradient(135deg, #0656a2, #3ca0a6);
      -webkit-mask: linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      z-index: -1;
    }
    &:not(:last-child) {
      margin-right: 2rem;
    }
    & span {
      color: var(--blue);
      font-weight: 600;
      display: block;
      margin-top: 0.5rem;
    }
  }
}
@media (max-width: 768px) {
  .dashBoradMessage {
    margin: 0;
    padding: 0 0 5vh;
    & button {
      width: 120px;
      height: 120px;
      &:not(:last-child) {
        margin-right: 1rem;
      }
    }
  }
  .menuWrap {
    margin-top: 3vh;
    & > a {
      width: 80px;
      height: 80px;
      padding: 1.5rem;
      &:not(:last-child) {
        margin-right: 1rem;
      }
      & span {
        color: var(--blue);
        font-weight: 600;
        display: block;
        margin-top: 0.5rem;
      }
    }
  }
}
</style>
<script>
import { clockIn, clockOut, cancelSeatReservation } from "@/services/api";
import ClockInModal from "@/components/ClockInModal.vue";
import CancelConfirmationModal from "@/components/CancelConfirmationModal.vue";
import { onMounted, onUnmounted } from "vue";
import api from "@/services/api";
import ConfirmationModal from "@/components/ConfirmationModal.vue";


export default {
  name: "DashboardView",
  components: { ClockInModal, CancelConfirmationModal,ConfirmationModal },
  computed: {
    userName() {
      return localStorage.getItem("userName") || "Guest";
    },
  },
  data() {
    return {
      today: "",
      currentTime: "",
      timerId: null,
      showClockInModal: false,
      showClockOutConfirmation: false,
      showCancelSeatConfirmation: false, // Add this
      cancelableReservationId: null, // Add this
      isClockedIn: false,
      isClockedOut: false,
      username: "Username", // Replace with actual user name retrieval logic
      formattedDate: "",
      timer: null,
    };
  },
  methods: {
    async checkAttendanceStatus() {
      try {
        const response = await api.get("/attendance/status/");
        if (response.data.status === "not_clocked_in") {
          this.isClockedIn = false;
          this.isClockedOut = false;
        } else {
          this.isClockedIn = true;
          this.isClockedOut = !!response.data.clock_out;
        }
      } catch (error) {
        console.error("Error checking attendance status:", error);
      }
    },
    openClockInModal() {
      this.showClockInModal = true;
    },
    async handleClockIn(workLocation) {
      this.showClockInModal = false;
      await this.performClockIn(workLocation);
    },
    async performClockIn(workLocation) {
      try {
        await clockIn({ work_location: workLocation });
        await this.checkAttendanceStatus();
        window.location.reload();
      } catch (error) {
        if (
          error.response &&
          error.response.status === 409 &&
          error.response.data.action_required === "cancel_seat"
        ) {
          this.cancelableReservationId = error.response.data.reservation_id;
          this.showCancelSeatConfirmation = true;
        } else {
          alert(
            "Clock In failed: " +
              (error.response?.data?.detail || "Unknown error")
          );
          console.error("Clock In error:", error.response?.data || error);
        }
      }
    },
    handleClockOut() {
      this.showClockOutConfirmation = true;
    },
    async confirmClockOut() {
      this.showClockOutConfirmation = false;
      try {
        await clockOut();
        await this.checkAttendanceStatus();
        window.location.reload();
      } catch (error) {
        alert("Clock Out failed.");
      }
    },
    cancelClockOut() {
      this.showClockOutConfirmation = false;
    },
    async confirmCancelSeatAndClockIn() {
      if (!this.cancelableReservationId) return;
      try {
        await cancelSeatReservation(this.cancelableReservationId);
        // After successful cancellation, try to clock in again.
        await this.performClockIn("Home");
      } catch (error) {
        alert("Failed to cancel seat reservation.");
        console.error("Seat cancellation or subsequent clock-in error:", error);
      } finally {
        this.showCancelSeatConfirmation = false;
        this.cancelableReservationId = null;
      }
    },
    cancelSeatCancellation() {
      this.showCancelSeatConfirmation = false;
      this.cancelableReservationId = null;
    },
    updateTime() {
      const now = this.$now();
      this.currentTime = now.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    updateDate() {
      const now = this.$now();
      const day = now.getDate();
      const month = now.toLocaleString("en-US", { month: "long" });
      const year = now.getFullYear();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      this.formattedDate = `${day} ${month} ${year}, ${hours}:${minutes}`;
    },
    async checkClockInStatus() {
      try {
        const response = await api.get("/clock-in-status/");
        if (response.data.show_clock_in_modal) {
          this.showClockInModal = true;
        }
      } catch (error) {
        console.error("Error checking clock in status:", error);
      }
    },
  },
  created() {
    this.today = this.$now().toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    this.updateDate();
    // Update time every minute
    this.timer = setInterval(this.updateDate, 60000);
  },
  async mounted() {
    this.updateTime();
    this.timerId = setInterval(this.updateTime, 60 * 1000);
    await this.checkAttendanceStatus();
    await this.checkClockInStatus();
  },
  beforeUnmount() {
    clearInterval(this.timerId);
    if (this.timer) clearInterval(this.timer);
  },
};
</script>
